import { TRootState } from "../@types";

export const selectModalProductGroups = (state: TRootState) =>
  state.productGroups.productGroupsModalIsOpen;

export const selectIsUpdateProductGroup = (state: TRootState) =>
  state.productGroups.isUpdateProductGroup;

export const selectProductGroupForUpdate = (state: TRootState) =>
  state.productGroups.productGroupForUpdate;

export const selectProductGroupsRefreshTable = (state: TRootState) =>
  state.productGroups.refreshTableProductGroups;
